import Bowser from "bowser";

const browser = Bowser.getParser(window.navigator.userAgent);
const isValidBrowser = browser.satisfies({
    "Microsoft Edge": ">=18",
    edge: ">=18",
    firefox: ">=58",
    chrome: ">=63",
    chromium: ">=63",
    safari: ">=11.1",
    opera: ">=50",
    brave: ">=63",
});
if (!isValidBrowser) {
    window.location = "/unsupported";
}
